import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedBlank: null,
  choices: [],
  isModalOpen: false,
  selectedChoice: "",
  feedback: "",
  isAnsweredCorrectly: false,
};

const optionsSlice = createSlice({
  name: "options",
  initialState,
  reducers: {
    setSelectedBlank: (state, action) => {
      state.selectedBlank = action.payload;
    },
    setChoices: (state, action) => {
      state.choices = action.payload;
    },
    setIsModalOpen: (state, action) => {
      state.isModalOpen = action.payload;
    },
    setSelectedChoice: (state, action) => {
      state.selectedChoice = action.payload;
    },
    setFeedback: (state, action) => {
      state.feedback = action.payload;
    },
    setIsAnsweredCorrectly: (state, action) => {
      state.isAnsweredCorrectly = action.payload;
    },
    resetUI: () => initialState,
  },
});

export const {
  setSelectedBlank,
  setChoices,
  setIsModalOpen,
  setSelectedChoice,
  setFeedback,
  setIsAnsweredCorrectly,
  resetUI,
} = optionsSlice.actions;
export default optionsSlice.reducer;
